import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import Logo from '../Images/Logo.webp';
import './MultiStepRegister.css';
import { Stepper, Step, StepLabel, makeStyles, Button, CircularProgress } from '@material-ui/core';
import PersonalDetailsForm from './PersonalDetailsForm';
import { useForm } from "react-hook-form";
import SkilsForm from './SkilsForm';
import { registerUser, socialMediaLink, userMetaData } from '../components/Models/AccountModel';
//import { saveFirstStepData, saveSecondStepData, selectFirstStepData, selectSecondStepData } from '../DataStore/Slices/userSlice';
//import { useSelector } from 'react-redux';
import server from '../Backend/axios';
import { checkIsUserExistsOrNot, candidateSignup } from '../Backend/firebase/auth';
import CheckUserProvider from '../AllHooks/CheckUserProvider';
import CustomAlert from '../components/CustomAlert';
import { checkValidation, createUserDocument, formParams, uploadCVDocument } from '../Backend/firebase/user';
import CheckIsEmailVerified from '../DataStore/Hooks/CheckIsEmailVerified';
import { loginSave } from '../DataStore/Slices/userSlice';
import { useDispatch } from 'react-redux';
import { getHoursPerWeekData, getPreferredContractData, sleep } from '../components/Models/CommonFunc';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '90%',
        margin: '2px auto',

        "& .MuiStepIcon-root.MuiStepIcon-active": {
            color: '#000000'
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed": {
            color: '#000000'
        }
    }
}));

function MultiStepRegister(props) {
    const [activeStep, setActiveStep] = useState(0);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors } = useForm();
    const [userRegisterForm, setUserRegisterForm] = useState({ registerUser: registerUser, socialMediaLink: socialMediaLink, userMetaData: userMetaData })
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { userData, firebaseUserData } = CheckUserProvider();
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const accessCode = new URLSearchParams(props.location.search).get('code');
    const isEmailVerified = CheckIsEmailVerified();
    const dispatch = useDispatch();
    const [isPageLoadCompletely, setIsPageLoadCompletely] = useState(false);
    const [cvDocument, setCvDocument] = useState(null);
    const [profilePhoto, setProfilePhoto] = useState(null);

    const onSubmit = async (data) => {
        let password = '';
        let user = null;
        if (activeStep === 0) {
            registerUser.nameTitle = data.nameTitle;
            registerUser.name = data.name;
            if (data.doe !== '')
                registerUser.doe = data.doe;
            registerUser.email = data.email;
            registerUser.cvDocument = data.cvDocument;

            registerUser.phoneNumber = data.phoneNumber;
            registerUser.profilePhoto = data.profilePhoto;
            registerUser.zipcode = data.zipcode;
            registerUser.houseNr = data.houseNr;

            socialMediaLink.facebookLink = data.facebookLink;
            socialMediaLink.githubLink = data.githubLink;
            socialMediaLink.instagramLink = data.instagramLink;
            socialMediaLink.linkedInLink = data.linkedInLink;
            socialMediaLink.stackOverFlowLink = data.stackOverFlowLink;
            socialMediaLink.twitterLink = data.twitterLink;

            // File Upload Setting
            if (data.cvDocument !== undefined && data.cvDocument !== '' && data.cvDocument !== null) {
                setCvDocument(data.cvDocument[0]);
            }

            if (data.profilePhoto !== undefined && data.profilePhoto !== '' && data.profilePhoto !== null) {
                setProfilePhoto(data.profilePhoto[0]);
            }
        } else if (activeStep === 1) {
            registerUser.currentCareerLevel = data.currentCareerLevel;
            registerUser.functionOrUniqueSKills = data.functionOrUniqueSKills;
            registerUser.productLevel = data.productLevel;
            registerUser.personalBio = data.personalBio;
            userMetaData.availableFrom = data.availableFrom;
            if (data.availableFromDate !== '')
                userMetaData.availableFromDate = data.availableFromDate;
            userMetaData.hourPerWeek = getHoursPerWeekData(data.hourPerWeek);
            userMetaData.maxTravelDistanceFromHome = data.maxTravelDistanceFromHome;
            userMetaData.maxTravelDistanceFromHomeKm = data.maxTravelDistanceFromHomeKm;
            userMetaData.preferredContract = getPreferredContractData(data.preferredContract);
            userMetaData.email = registerUser.email;
            password = data.password;
        }

        if (activeStep === 1) {
            let createDataForFirebase = {
                fullName: registerUser.name,
                email: registerUser.email,
                password: password,
                roleName: 'User',
                nameTitle: formParams(data?.nameTitle),
                name: formParams(data?.name),
                doe: checkValidation(data?.doe) ? data.doe : new Date(),
                cvDocument: formParams(data?.cvDocument),
                phoneNumber: formParams(data?.phoneNumber),
                profilePhoto: formParams(data?.profilePhoto),
                zipcode: formParams(data?.zipcode),
                facebookLink: formParams(data?.facebookLink),
                githubLink: formParams(data?.githubLink),
                instagramLink: formParams(data?.instagramLink),
                linkedInLink: formParams(data?.linkedInLink),
                stackOverFlowLink: formParams(data?.stackOverFlowLink),
                twitterLink: formParams(data?.twitterLink),
                currentCareerLevel: formParams(data?.currentCareerLevel),
                functionOrUniqueSKills: formParams(data?.functionOrUniqueSKills),
                productLevel: formParams(data?.productLevel),
                personalBio: formParams(data?.personalBio),
                availableFrom: formParams(data?.availableFrom),
                availableFromDate: formParams(data?.availableFromDate),
                hourPerWeek: checkValidation(data?.hourPerWeek) ? getHoursPerWeekData(data?.hourPerWeek) : null,
                maxTravelDistanceFromHome: formParams(data?.maxTravelDistanceFromHome),
                maxTravelDistanceFromHomeKm: formParams(data?.maxTravelDistanceFromHomeKm),
                preferredContract: checkValidation(data?.preferredContract) ? getPreferredContractData(data.preferredContract) : ''
            };
            user = await candidateSignup(createDataForFirebase);
            if (user != null) {
                registerUser.uid = user.uid;
                socialMediaLink.uid = user.uid;
                userMetaData.uid = user.uid;
                if (cvDocument) {
                    var cvPath = `Resumes/${user.uid}/${registerUser.name}_CV.${cvDocument.name.split('.').pop()}`;
                    await uploadCVDocument(cvPath, cvDocument);
                    registerUser.cvDocumentPath = cvPath;
                }

                if (profilePhoto) {
                    var photoPathData = `users/${user.uid}/${registerUser.name}_Photo.${profilePhoto.name.split('.').pop()}`;
                    await uploadCVDocument(photoPathData, profilePhoto);
                    registerUser.profilePhotoPath = photoPathData;
                }
                history.push('/');
            }
            // if (!accessCode) {
            //     user = await signup(createDataForFirebase);
            //     if (user != null) {
            //         registerUser.uid = user.uid;
            //         socialMediaLink.uid = user.uid;
            //         userMetaData.uid = user.uid;
            //         if (cvDocument) {
            //             var cvPath = `Resumes/${user.uid}/${registerUser.name}_CV.${cvDocument.name.split('.').pop()}`;
            //             var cvRef = await uploadCVDocument(cvPath, cvDocument);
            //             registerUser.cvDocumentPath = cvPath;
            //         }

            //         if (profilePhoto) {
            //             var photoPathData = `users/${user.uid}/${registerUser.name}_Photo.${profilePhoto.name.split('.').pop()}`;
            //             var photoRef = await uploadCVDocument(photoPathData, profilePhoto);
            //             registerUser.profilePhotoPath = photoPathData;
            //         }
            //         registerWithDb(registerUser, socialMediaLink, userMetaData, user);
            //     }
            // }
            // else {
            //     registerWithDb(registerUser, socialMediaLink, userMetaData);
            // }
        }

        if (activeStep === 1) {

        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
        setIsLoading(false);
    };

    const registerWithDb = async (registerUser, socialMediaLink, userMetaData, user = null) => {
        try {
            if (accessCode) {
                await server.get(`/Account/GetLinkedInProfileAsync?accessCode=${accessCode}`)
                    .then((res) => {
                        if (res.status === 200) {
                            console.log(res);
                            sessionStorage.setItem("access_token", res.data.data.access_token);
                            dispatch(loginSave({
                                user: res.data.data
                            }));
                        }
                    }).catch(err => console.log(err));
            }

            let registerUserResponse = 0;
            await server.post('/Account/RegisterNormalUserAsync', {
                user: registerUser,
                socialMediaLink: socialMediaLink
            }).then((response) => registerUserResponse = response.status)
                .catch(err => console.log(err));

            if (registerUserResponse === 200) {
                let userMetaDataResponse = null;
                await server.post("/Account/UpdateUserMetaDataAsync", userMetaData)
                    .then((response) => userMetaDataResponse = response.data)
                    .catch(err => console.log(err));

                if (userMetaDataResponse.message === "success") {
                    if (!accessCode) {
                        // if (isEmailVerified) {
                        history.push('/');
                        // } else {
                        //     user.sendEmailVerification().then((resp) => {
                        //         // console.log("Verify => ", resp);
                        //     }).catch(function (error) {
                        //         console.log(error);
                        //     });
                        //     history.push('/emailalert');
                        // }
                    }
                    else {
                        history.push('/');
                    }
                }
            }
        } catch (error) {
            console.log('Exception => ', error.message);
        };
    }

    useEffect(async () => {
        let isUserExist = null;
        if (accessCode) {
            await server.get(`/Account/GetLinkedInProfileAsync?accessCode=${accessCode}`)
                .then(async (res) => {
                    if (res.status === 200) {
                        sessionStorage.setItem("access_token", res.data.data.access_token);
                        dispatch(loginSave({
                            user: res.data.data
                        }));
                        isUserExist = res.data.data;
                        history.push("/");
                    }
                }).catch(err => console.log(err));
            if (isUserExist === null) {
                setIsPageLoadCompletely(true);
            }
        }
        else {
            setIsPageLoadCompletely(true);
        }
    }, []);

    const handleSkipRegistration = async () => {
        if (accessCode) {
            await server.get(`/Account/GetLinkedInProfileAsync?accessCode=${accessCode}`)
                .then((res) => {
                    if (res.status === 200) {
                        console.log(res);
                        sessionStorage.setItem("access_token", res.data.data.access_token);
                        dispatch(loginSave({
                            user: res.data.data
                        }));
                        history.push("/");
                    }
                }).catch(err => console.log(err));
        }
        else {
            if (userData) {
                try {
                    let uid = '';
                    if (userData.provider === "google.com") {
                        await createUserDocument(firebaseUserData, 'User');
                    }
                    if (firebaseUserData) {
                        uid = firebaseUserData.uid;
                    }

                    let registerUserResponse = 0;
                    registerUser.uid = uid;
                    registerUser.email = firebaseUserData.email;
                    registerUser.name = firebaseUserData.displayName;
                    socialMediaLink.uid = uid;
                    userMetaData.uid = uid;
                    userMetaData.email = firebaseUserData.email;
                    await server.post('/Account/RegisterNormalUserAsync', {
                        user: registerUser,
                        socialMediaLink: socialMediaLink
                    }).then((response) => registerUserResponse = response.status)
                        .catch(err => console.log(err));

                    if (registerUserResponse === 200) {
                        let userMetaDataResponse = null;
                        await server.post("/Account/UpdateUserMetaDataAsync",
                            userMetaData).then((response) => userMetaDataResponse = response.data)
                            .catch(err => console.log(err));

                        if (userMetaDataResponse.message === "success") {
                            history.push('/');
                        }
                    }
                } catch (error) {
                    setNotificationMessage(error.message);
                    setOpenNotify(true);
                    setAlertType('error');
                }
            }
            else {
                setNotificationMessage('You can not do this action, please reload the page first!');
                setOpenNotify(true);
                setAlertType('error');
            }
        }
    };

    // const getHoursPerWeekData = (hoursPerWeek) => {
    //     let result = '';
    //     for (const item in hoursPerWeek) {
    //         //console.error(item);
    //         if (item === "EightHours" && hoursPerWeek[item] === true) {
    //             result = result + '8 hrs,';
    //         } else if (item === "SixteenHours" && hoursPerWeek[item] === true) {
    //             result = result + '16 hrs,';
    //         } else if (item === "TwentyFourHours" && hoursPerWeek[item] === true) {
    //             result = result + '24 hrs,';
    //         } else if (item === "ThirtyTwoHours" && hoursPerWeek[item] === true) {
    //             result = result + '32 hrs,';
    //         } else if (item === "ThirtySixHours" && hoursPerWeek[item] === true) {
    //             result = result + '36 hrs,';
    //         } else if (item === "FourtyHours" && hoursPerWeek[item] === true) {
    //             result = result + '40 hrs,';
    //         } else {
    //             console.log('Week Per Hours Null!');
    //         }
    //     }
    //     return result;
    // };

    // const getPreferredContractData = (preferredContract) => {
    //     let result = '';
    //     for (const item in preferredContract) {
    //         if (item === "capsule" && preferredContract[item] === true) {
    //             result = result + 'Capsule,';
    //         } else if (item === "freelance" && preferredContract[item] === true) {
    //             result = result + 'Freelance,';
    //         } else if (item === "sideProduct" && preferredContract[item] === true) {
    //             result = result + 'Side Product,';
    //         } else if (item === "temporaryContract" && preferredContract[item] === true) {
    //             result = result + 'Temporary Contract,';
    //         } else if (item === "internship" && preferredContract[item] === true) {
    //             result = result + 'Internship,';
    //         } else if (item === "syrup" && preferredContract[item] === true) {
    //             result = result + 'Syrup,';
    //         } else if (item === "traineeship" && preferredContract[item] === true) {
    //             result = result + 'Traineeship,';
    //         } else {
    //             console.log('Week Per Hours Null!');
    //         }
    //     }
    //     return result;
    // };

    function getSteps() {
        return ['Your Personal Details', 'Your Skills'];
    }

    const steps = getSteps();

    function getStepContext(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <PersonalDetailsForm handleSubmit={handleSubmit(onSubmit)} register={register} activeStep={activeStep}
                    errors={errors} steps={steps} userRegisterForm={userRegisterForm} setUserRegisterForm={setUserRegisterForm}
                    handleSkipRegistration={handleSkipRegistration} accessCode={accessCode} setValue={setValue} />;
            case 1:
                return <SkilsForm handleSubmit={handleSubmit(onSubmit)} register={register} activeStep={activeStep}
                    errors={errors} steps={steps} userRegisterForm={userRegisterForm} setUserRegisterForm={setUserRegisterForm}
                    isLoading={isLoading} setIsLoading={setIsLoading} setValue={setValue} />;
            default:
                return 'Unknown Step';
        }
    }

    return (
        <>
            {isPageLoadCompletely ?
                <div className="container-fluid registerRetailer">
                    <Helmet>
                        <meta name="description" content="To register yourself with this career website for your future dream products..." />
                        <title>User Registration | Kaipsool Pharmatech</title>
                    </Helmet>
                    <div className="row">
                        <div className="col-10 mx-auto">
                            <div className="row multiStepRegister">
                                <div className="col-md-12 text-center">
                                    <NavLink className="" to="/">
                                        <img className="img-fluid" src={Logo} alt="Website Logo" width="200px" />
                                        {/* &nbsp;
                                        <span className="text-start navbar-brand-text">Kaipsool Pharmatech</span> */}
                                    </NavLink>
                                    <h5 className="multiStepRegister__pageTitle"><span>User Registration Portal</span></h5>
                                </div>
                                <div className="col-md-12">
                                    <div className={classes.root}>
                                        <Stepper activeStep={activeStep} alternativeLabel>
                                            {steps.map((label) => (
                                                <Step key={label}>
                                                    <StepLabel>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                        {getStepContext(activeStep)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default MultiStepRegister;
